var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21.6923,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#393ABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08576 12.1923L3.58579 12.6922C3.21071 13.0673 3 13.576 3 14.1064V17.6922C3 18.7968 3.89543 19.6922 5 19.6922H8.58579C9.11622 19.6922 9.62493 19.4815 10 19.1064L10.5 18.6065L4.08576 12.1923Z",
    fill: "#393ABD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10.778L11.5858 4.69226L18 11.1065L11.9142 17.1923L5.5 10.778Z",
    fill: "#393ABD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1214 2.39931C16.9498 1.22774 15.0503 1.22774 13.8787 2.39931L13 3.27802L19.4142 9.69223L20.2929 8.81352C21.4645 7.64195 21.4645 5.74246 20.2929 4.57088L18.1214 2.39931Z",
    fill: "#393ABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b6333282a87d4112b1a8ff149db91037.svg";
export { ForwardRef as ReactComponent };